export default __webpack_public_path__ + "static/media/mic-fill.c3de08d5.svg";